document.querySelectorAll('[data-product-form]').forEach((form) => {
  const price = form.closest('.product-main__information')?.querySelector('[data-product-price]');
  const addButton = form.querySelector('[data-product-add]');

  form.querySelectorAll('[data-variant-input]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;

      const available = input.dataset.available === 'true';
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      if (!addButton) return;

      addButton.disabled = !available;
      addButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      addButton.textContent = available
        ? addButton.dataset.labelAvailable
        : addButton.dataset.labelUnavailable;
    });
  });
});
